/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Content.ContainerTagKey_
///   This is an auto-generated enumeration of the SWFC_Learning.Content.ContainerTagKey domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum ContainerTagKey_ {
   /// <summary>
   ///   Sequence (seq)
   /// </summary>
   Sequence = 1,
   /// <summary>
   ///   Depends On (depon)
   /// </summary>
   DependsOn = 2,
   /// <summary>
   ///   Points (points)
   /// </summary>
   Points = 3,
   /// <summary>
   ///   Status (status)
   /// </summary>
   Status = 4,
   /// <summary>
   ///   Search Terms (search)
   /// </summary>
   SearchTerms = 5,
   /// <summary>
   ///   Collection (col)
   /// </summary>
   Collection = 6
}

export const ContainerTagKeys: ContainerTagKey[] = [
   {
      code: ContainerTagKey_.Sequence,
      literal: 'Sequence',
      description: 'Sequence',
      shortDescription: 'seq',
      listPriority: 0,

      typeName: "ContainerTagKey"
   },
   {
      code: ContainerTagKey_.DependsOn,
      literal: 'DependsOn',
      description: 'Depends On',
      shortDescription: 'depon',
      listPriority: 0,

      typeName: "ContainerTagKey"
   },
   {
      code: ContainerTagKey_.Points,
      literal: 'Points',
      description: 'Points',
      shortDescription: 'points',
      listPriority: 0,

      typeName: "ContainerTagKey"
   },
   {
      code: ContainerTagKey_.Status,
      literal: 'Status',
      description: 'Status',
      shortDescription: 'status',
      listPriority: 0,

      typeName: "ContainerTagKey"
   },
   {
      code: ContainerTagKey_.SearchTerms,
      literal: 'SearchTerms',
      description: 'Search Terms',
      shortDescription: 'search',
      listPriority: 0,

      typeName: "ContainerTagKey"
   },
   {
      code: ContainerTagKey_.Collection,
      literal: 'Collection',
      description: 'Collection',
      shortDescription: 'col',
      listPriority: 0,

      typeName: "ContainerTagKey"
   }
]

export class ContainerTagKey implements IDomainModel {
   code: ContainerTagKey_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   typeName: string

   static toDomainModel(code: ContainerTagKey_): ContainerTagKey {
      return ContainerTagKeys.find(d => d.code === code)
   }
}
